import UserService from '../services/user.services';
import { User } from '../types/User';

const UserController = class UserController {
    public async getAllUsers(): Promise<User[]> {
        return UserService.getAllUsers();
    }
};

export default new UserController();
